(function () {
  'use strict';

  var PESOS = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];

  /* Digito de verificacion del NIT, algoritmo de la DIAN. Se calcula en lugar
     de pedirlo: escrito a mano es la causa mas comun de rechazo de factura. */
  function calcularDv(nit) {
    var d = String(nit).replace(/\D/g, '');
    if (!d) return '';
    var suma = 0;
    for (var i = 0; i < d.length; i++) {
      suma += parseInt(d.charAt(d.length - 1 - i), 10) * PESOS[i];
    }
    var r = suma % 11;
    return String(r < 2 ? r : 11 - r);
  }

  /* Cada bloque se gobierna solo. Hace falta porque en la pagina de cuenta
     conviven dos: el formulario de la cuenta y el dialogo, que se pinta en
     todas las paginas. Un unico querySelector cogeria el primero y dejaria el
     otro muerto. */
  function iniciar(raiz) {
    if (raiz.dataset.hzfisListo) return;
    raiz.dataset.hzfisListo = '1';

    var conSesion = raiz.hasAttribute('data-hzfis-sesion');
    var tipo = raiz.querySelector('[data-hzfis-tipo]');
    var num = raiz.querySelector('[data-hzfis-num]');
    var dv = raiz.querySelector('[data-hzfis-dv]');
    var mail = raiz.querySelector('[data-hzfis-mail]');
    var razon = raiz.querySelector('[data-hzfis-razon]');
    var error = raiz.querySelector('[data-hzfis-error]');

    function esNit() { return /^31/.test(tipo.value); }
    function esJuridica() {
      var m = raiz.querySelector('[data-hzfis-persona]:checked');
      return Boolean(m) && m.value === 'Jurídica';
    }

    function mostrar(sel, visible) {
      raiz.querySelectorAll(sel).forEach(function (el) {
        el.hidden = !visible;
        // Un campo oculto no puede seguir siendo obligatorio: bloquearia el
        // envio sin que nadie vea por que.
        el.querySelectorAll('input, select').forEach(function (c) {
          if (c.required && !c.dataset.hzfisReq) c.dataset.hzfisReq = '1';
          if (c.dataset.hzfisReq) c.required = visible;
        });
      });
    }

    function pintar() {
      mostrar('[data-hzfis-solo-nit]', esNit());
      mostrar('[data-hzfis-solo-juridica]', esJuridica());
      dv.value = esNit() ? calcularDv(num.value) : '';
    }

    function recoger() {
      var attrs = {};
      raiz.querySelectorAll('[name^="attributes["]').forEach(function (c) {
        attrs[c.name.slice(11, -1)] = c.value;
      });
      // Los radios llevan un nombre propio de cada bloque: dos radios con el
      // mismo name forman un solo grupo aunque esten en formularios distintos,
      // y el segundo bloque desmarcaba al primero. Su clave viaja aparte.
      var persona = raiz.querySelector('[data-hzfis-persona]:checked');
      if (persona) attrs[persona.getAttribute('data-hzfis-clave')] = persona.value;
      return attrs;
    }

    function validar() {
      var faltan = [];
      if (!num.value.trim()) faltan.push('el numero de documento');
      if (mail.value.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail.value)) {
        faltan.push('un correo valido');
      }
      if (esJuridica() && razon && !razon.value.trim()) faltan.push('la razon social');

      num.setAttribute('aria-invalid', num.value.trim() ? 'false' : 'true');
      if (!faltan.length) { error.hidden = true; return true; }
      error.textContent = 'Para emitir tu factura necesitamos ' + faltan.join(' y ') + '.';
      error.hidden = false;
      return false;
    }

    function guardarEnCarrito() {
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: recoger() })
      });
    }

    /* Con sesion se guarda tambien en la ficha, para que la proxima compra
       venga rellena. Va por el App Proxy porque escribir en el cliente exige
       la Admin API, que no puede vivir en el navegador. */
    function guardarEnFicha() {
      if (!conSesion) return Promise.resolve(false);
      var a = recoger();
      if (!a['Número de documento']) return Promise.resolve(false);
      return fetch(window.Shopify.routes.root + 'apps/asesor/fiscales', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo_persona: a['Tipo de persona'] || '',
          tipo_documento: a['Tipo de documento'] || '',
          numero_documento: a['Número de documento'] || '',
          dv: a['DV'] || '',
          razon_social: a['Razón social'] || '',
          responsabilidad_fiscal: a['Responsabilidad fiscal'] || '',
          correo_fe: a['Correo factura electrónica'] || ''
        })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    tipo.addEventListener('change', pintar);
    num.addEventListener('input', pintar);
    raiz.querySelectorAll('[data-hzfis-persona]').forEach(function (r) {
      r.addEventListener('change', pintar);
    });

    raiz.hzfis = {
      validar: validar,
      guardarEnCarrito: guardarEnCarrito,
      guardarEnFicha: guardarEnFicha,
      recoger: recoger,
      completo: function () {
        return Boolean(num.value.trim()) &&
               (!esJuridica() || !razon || Boolean(razon.value.trim()));
      }
    };

    // Boton de la pagina de cuenta. Aqui si se informa del resultado: la
    // persona vino expresamente a guardar y merece saber si salio bien.
    var botonGuardar = raiz.querySelector('[data-hzfis-guardar]');
    if (botonGuardar) {
      var estado = raiz.querySelector('[data-hzfis-estado]');
      var etiqueta = botonGuardar.getAttribute('data-hzfis-etiqueta') || 'Guardar';
      botonGuardar.addEventListener('click', function () {
        if (!validar()) return;
        botonGuardar.disabled = true;
        estado.textContent = 'Guardando...';
        guardarEnFicha().then(function (ok) {
          botonGuardar.disabled = false;
          // Tras el primer guardado ya hay datos, asi que el boton pasa a
          // describir el acto siguiente: actualizar, no crear.
          botonGuardar.textContent = ok ? 'Actualizar' : etiqueta;
          estado.textContent = ok ? 'Guardado' : 'No se pudo guardar. Intentalo de nuevo.';
          if (ok) setTimeout(function () { estado.textContent = ''; }, 4000);
        });
      });
    }

    pintar();
  }

  document.querySelectorAll('[data-hzfis]').forEach(iniciar);

  /* ── El paso previo al pago ──────────────────────────────────────────────
     Se intercepta el boton de pagar en vez de poner los campos en la pagina
     del carrito. Asi cubre TAMBIEN el cajon lateral, que es por donde se paga
     la mayoria de las veces y donde no cabe un formulario.

     Se muestra SIEMPRE, tambien cuando los datos ya estan guardados: llegan
     rellenos y la persona solo confirma o corrige. En B2B es habitual comprar
     hoy a nombre de una empresa y manana de otra, y una factura emitida con
     los datos de la compra anterior no se puede rehacer sin una nota credito. */
  var dialogo = document.querySelector('[data-hzfis-dialogo]');
  if (!dialogo) return;

  var bloque = dialogo.querySelector('[data-hzfis]');
  var envioPendiente = null;
  var botonPendiente = null;

  /* Reenviar el formulario NO basta con form.submit(): ese metodo no incluye
     el name/value del boton que lo disparo, y sin `checkout` Shopify trata el
     envio como una simple actualizacion del carrito y te devuelve a /cart.
     requestSubmit(boton) si lo incluye. */
  /* Prefill del checkout (envio y retiro): con lo que sabemos del cliente
     (data-hzfis-prefill, puesto por Liquid) mas lo recien escrito en el
     dialogo (correo de factura y razon social mandan). Shopify lee estos
     parametros `checkout[...]` al abrir /checkout. Sin datos, se sigue por el
     formulario como siempre. */
  function urlCheckoutPrefill() {
    var crudo = dialogo.getAttribute('data-hzfis-prefill');
    var pre = {};
    try { if (crudo) pre = JSON.parse(crudo) || {}; } catch (e) { pre = {}; }
    /* Cliente sin sesion que llego por el enlace de WhatsApp: el prellenado
       vino en la URL y quedo en sessionStorage (horeca-carrito-enlace). */
    try {
      var guardado = JSON.parse(sessionStorage.getItem('hz:prefill') || '{}');
      Object.keys(guardado).forEach(function (k) {
        var m = k.match(/^shipping_address\]\[(.+)$/);
        var clave = m ? m[1] : k;
        if (guardado[k] && !pre[clave]) pre[clave] = guardado[k];
      });
    } catch (e) {}
    var a = (bloque.hzfis.recoger && bloque.hzfis.recoger()) || {};
    if (a['Correo factura electrónica']) pre.email = a['Correo factura electrónica'];
    if (a['Tipo de persona'] === 'Jurídica' && a['Razón social']) pre.company = a['Razón social'];
    var p = new URLSearchParams();
    if (pre.email) p.set('checkout[email]', pre.email);
    ['first_name', 'last_name', 'company', 'phone', 'address1', 'address2', 'city', 'province', 'zip', 'country'].forEach(function (k) {
      if (pre[k]) p.set('checkout[shipping_address][' + k + ']', pre[k]);
    });
    if (![...p.keys()].length) return null;
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout?' + p.toString();
  }

  function seguirAlPago() {
    if (!envioPendiente) return;
    var prefill = urlCheckoutPrefill();
    if (prefill) { window.location.href = prefill; return; }
    if (envioPendiente.requestSubmit && botonPendiente) {
      envioPendiente.requestSubmit(botonPendiente);
      return;
    }
    // Navegadores sin requestSubmit: se anade el nombre a mano.
    var oculto = document.createElement('input');
    oculto.type = 'hidden';
    oculto.name = 'checkout';
    oculto.value = '';
    envioPendiente.appendChild(oculto);
    envioPendiente.submit();
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[name="checkout"]');
    if (!boton || !bloque || !bloque.hzfis) return;

    e.preventDefault();
    e.stopPropagation();
    envioPendiente = boton.form || boton.closest('form');
    botonPendiente = boton;
    dialogo.showModal();
  }, true);

  dialogo.querySelector('[data-hzfis-continuar]').addEventListener('click', function () {
    if (!bloque.hzfis.validar()) return;
    var boton = this;
    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Un momento...';

    // Primero el carrito, de donde salen los datos del pedido; despues la
    // ficha, que solo es comodidad para la proxima vez. Si la ficha falla, la
    // compra sigue adelante igualmente.
    bloque.hzfis.guardarEnCarrito()
      .then(function () { return bloque.hzfis.guardarEnFicha(); })
      .catch(function () { return false; })
      .then(function () {
        dialogo.dataset.hzfisGuardado = '1';
        dialogo.close();
        boton.disabled = false;
        boton.textContent = textoOriginal;
        seguirAlPago();
      });
  });

  dialogo.querySelector('[data-hzfis-cancelar]').addEventListener('click', function () {
    dialogo.close();
  });

  /* Los atributos pueden haberse escrito por Ajax y la pagina venir
     renderizada sin ellos (cliente sin sesion): se leen del carrito en vivo y
     se vuelcan a los campos, que quedan editables. */
  function rellenarDesdeCarrito() {
    var raizRuta = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    return fetch(raizRuta + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var a = (c && c.attributes) || {};
        /* Los <select> siempre traen un valor por defecto: se pisan; los
           campos de texto solo si estan vacios (lo escrito manda). */
        var pon = function (sel, v) { var el = bloque.querySelector(sel); if (el && v && (el.tagName === 'SELECT' || !el.value)) { el.value = v; el.dispatchEvent(new Event('change', { bubbles: true })); el.dispatchEvent(new Event('input', { bubbles: true })); } };
        if (a['Tipo de persona']) {
          var radio = bloque.querySelector('[data-hzfis-persona][value="' + a['Tipo de persona'] + '"]');
          if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        pon('[data-hzfis-razon]', a['Razón social']);
        pon('[data-hzfis-tipo]', a['Tipo de documento']);
        pon('[data-hzfis-num]', a['Número de documento']);
        pon('#hzfis-resp-dialogo', a['Responsabilidad fiscal']);
        pon('[data-hzfis-mail]', a['Correo factura electrónica']);
      })
      .catch(function () {});
  }

  /* Llegada desde el enlace de WhatsApp o de «Compartir carrito»
     (/cart?fiscal=1): el carrito ya esta armado y los datos fiscales ya son
     atributos, asi que el dialogo se abre solo, relleno y editable, con el
     boton de pagar de la pagina como destino. */
  if (new URLSearchParams(location.search).get('fiscal') === '1' && bloque && bloque.hzfis) {
    var botonPagar = document.querySelector('form[action*="/cart"] [name="checkout"], [name="checkout"]');
    if (botonPagar) {
      envioPendiente = botonPagar.form || botonPagar.closest('form');
      botonPendiente = botonPagar;
    }
    rellenarDesdeCarrito().then(function () { try { dialogo.showModal(); } catch (e) {} });
  }

  /* Boton «Datos de facturación» del carrito y del cajon (2026-09-30): abre
     el mismo dialogo SIN ir al pago. «Guardar datos» los deja en el carrito
     (y en la ficha si hay sesion); asi viajan tambien al compartir el
     carrito. */
  var botonOk = dialogo.querySelector('[data-hzfis-continuar]');
  var textoOk = botonOk.textContent;
  var abridor = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hzfis-abrir]');
    if (!b || !bloque || !bloque.hzfis) return;
    e.preventDefault();
    envioPendiente = null;
    botonPendiente = null;
    abridor = b;
    botonOk.textContent = 'Guardar datos';
    rellenarDesdeCarrito().then(function () { try { dialogo.showModal(); } catch (err) {} });
  });
  dialogo.addEventListener('close', function () {
    botonOk.textContent = textoOk;
    if (abridor && dialogo.dataset.hzfisGuardado === '1') {
      var caja = abridor.closest('.hz-comp');
      var aviso = caja && caja.querySelector('.hz-comp__aviso');
      if (aviso) { aviso.textContent = '✓ Datos de facturación guardados.'; setTimeout(function () { aviso.textContent = ''; }, 3000); }
    }
    abridor = null;
    delete dialogo.dataset.hzfisGuardado;
  });

  /* Para «Compartir carrito»: lo que muestra el formulario ahora mismo
     (datos del carrito o, con sesion, los de la ficha). */
  window.hzFiscales = {
    recoger: function () { return bloque.hzfis.recoger(); },
    completo: function () { return bloque.hzfis.completo(); }
  };
})();
